import React from "react";
import styles from "./Button.module.scss";

interface ButtonProps {
  text: string;
  onClick: () => void;
  outlined?: boolean;
  disabled?: boolean;
  variant?: "default" | "primary" | "danger";
  className?: string;
}

const Button: React.FC<ButtonProps> = ({
  text,
  onClick,
  outlined = false,
  disabled = false,
  variant = "default",
  className = "",
}) => {
  return (
    <button
      className={`
        ${styles.button} 
        ${outlined ? styles.outlined : ""} 
        ${disabled ? styles.disabled : ""}
        ${styles[variant]}
        ${className}
      `}
      onClick={onClick}
      disabled={disabled}
    >
      {text}
    </button>
  );
};

export default Button;
